import { useSearchParams } from "react-router-dom";

const useQueryParams = (key: string, defaultValue?: string) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const value = searchParams.get(key) ?? defaultValue;
    const handleChangeValue = (value: string) => {
        setSearchParams((prev) => {
            const _prev = Object.fromEntries(new URLSearchParams(prev));
            return { ..._prev, [key]: value };
        });
    };

    return [value, handleChangeValue] as [string, (value: string) => void];
};

export default useQueryParams;
